import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import * as LucideIcons from 'lucide-react';

const RiskCardItem = ({ card, onEdit, onDelete }) => {
    // Dynamically get the icon component from Lucide
    const IconComponent = LucideIcons[card.icon_name] || LucideIcons.HelpCircle;

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group">
            {/* Gradient Header */}
            <div className={`h-2 bg-gradient-to-r ${card.gradient_from}`}></div>

            <div className="p-5">
                <div className="flex items-start justify-between mb-4">
                    {/* Icon Container */}
                    <div className={`p-3 rounded-xl bg-gradient-to-br ${card.gradient_from} text-white shadow-sm`}>
                        <IconComponent className="h-6 w-6" />
                    </div>

                    {/* Actions */}
                    <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                            onClick={() => onEdit(card)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-primary-600 transition-colors"
                            title="Edit"
                        >
                            <PencilIcon className="h-5 w-5" />
                        </button>
                        <button
                            onClick={() => onDelete(card.id)}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-red-600 transition-colors"
                            title="Delete"
                        >
                            <TrashIcon className="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <div className="space-y-2">
                    <div className="flex items-center justify-between">
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${card.is_active ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'}`}>
                            {card.is_active ? 'Active' : 'Inactive'}
                        </span>
                        <span className="text-[10px] font-bold text-slate-400">ORDER #{card.display_order}</span>
                    </div>
                    <div>
                        <h4 className="text-sm font-semibold text-slate-500 uppercase tracking-wide">{card.title}</h4>
                        <p className="text-2xl font-bold text-slate-800">{card.description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RiskCardItem;
